import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/shared/stores/auth';
import { searchApplicationByLuggageQr } from '../api/searchApplicationByLuggageQr';

export const useLuggageQrSearch = () => {
    const router = useRouter();
    const { role } = useAuth();
    const isLoading = ref(false);
    const errorMessage = ref<string | null>(null);

    const handleLuggageQrDetect = async (qrCode: string): Promise<boolean> => {
        isLoading.value = true;
        errorMessage.value = null;

        try {
            const data = await searchApplicationByLuggageQr(qrCode);
            const applications = data.applications ?? [];

            const firstApplication = applications[0];
            if (!firstApplication) {
                errorMessage.value = '該当するQRコードがありません';
                return false;
            }

            const applicationId = firstApplication.application_id;

            // 配送ステータスに応じて次の作業画面へ遷移する
            switch (firstApplication.delivery_status) {
                // ホテル到着後は荷物検品（ホテル・管理者）
                case 'hotel_arrived':
                    router.push({ name: 'luggage-inspection' });
                    return true;
                // 検品済みは旅行者への受け渡し
                case 'hotel_checked':
                    router.push({
                        name: 'application.traveler-handover',
                        params: { applicationId },
                    });
                    return true;
                // 配送中はホテル権限のみ荷物検品へ、SC・管理者は詳細画面
                case 'in_transit':
                    if (role.value.isHotel) {
                        router.push({ name: 'luggage-inspection' });
                        return true;
                    }
                    router.push({
                        name: 'application-detail',
                        params: { applicationId },
                    });
                    return true;
                // 上記以外（預かり・受け取り完了・キャンセル・遅延）は詳細画面
                case 'airport_counter_received':
                case 'delivery_completed':
                case 'cancelled':
                case 'delayed':
                    router.push({
                        name: 'application-detail',
                        params: { applicationId },
                    });
                    return true;
                // applied（預かり前）は荷物QRが未登録のため到達しない想定
                default:
                    errorMessage.value = '該当するQRコードがありません';
                    return false;
            }
        } catch {
            errorMessage.value = '該当するQRコードがありません';
            return false;
        } finally {
            isLoading.value = false;
        }
    };

    return {
        isLoading,
        errorMessage,
        handleLuggageQrDetect,
    };
};
